import {REPORT_METRICS_LOAD_REQUEST, REPORT_METRICS_LOAD_SUCCESS} from "./report-metrics-actions";

const initialState = {
  loading: false,
  reportMetrics: [],
}

const reportMetricsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REPORT_METRICS_LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case REPORT_METRICS_LOAD_SUCCESS:
      return {
        loading: false,
        reportMetrics: action.reportMetrics
      };

    default:
      return state;

  }
}

export default reportMetricsReducer;
